import precisionRequest from './precision.request';
import createService from '../Utils/createService';
import handleServiceError from '../Utils/handleServiceError';
import { ServiceTypes } from '../Constants/api.constants';
import {
    RETRY_COUNT_API_SERVICE_PRECISION,
} from '../../Errors/Constants/Error.retries';

const createPrecisionService = (configStoreUpdate$, handleError) =>
    createService(
        ServiceTypes.PRECISION,
        configStoreUpdate$,
        precisionRequest,
        handleServiceError(ServiceTypes.PRECISION, handleError),
        RETRY_COUNT_API_SERVICE_PRECISION,
    );

export default createPrecisionService;
